import axios from '@/axios';

export default {
  fetchMethods() {
    return axios.get('/api/v1/admins/product-methods');
  },
  createMethod(_, data) {
    return axios.post('/api/v1/admins/product-methods', data);
  },
  updateMethod(_, data) {
    return axios.patch(`/api/v1/admins/product-methods/${data._id}`, data);
  },
  deleteMethod(_, data) {
    return axios.delete(`/api/v1/admins/product-methods/${data._id}`);
  },
};
